import React from "react";
import Button from "react-bootstrap/Button";

const GpsStatus = ({ data, handleClose }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full z-30 bg-black/50 flex items-center justify-center">
      <div className="p-3 rounded-lg text-center bg-white shadow-lg min-w-[300px]">
        <p className="text-2xl font-bold">GPS Status</p>
        <p className="text-sm my-2 capitalize">
          Client Id: {data?.client_id || "N/A"}
        </p>
        <p className="text-sm my-2 capitalize">
          Status: {data?.status || "N/A"}
        </p>
        <p className="text-sm my-2 mb-4">
          Arrival Time: {data?.arrival_time || "N/A"}
        </p>
        <Button onClick={handleClose}>Close</Button>
      </div>
    </div>
  );
};

export default GpsStatus;
